import React, {
	Component
} from 'react';

import { Button } from 'react-bootstrap';
import './style.css';
var conf = require('../../conf');

export default class ForgotPassword extends Component{
	constructor(props){
		super(props);
		this.state={
			...props,
			username: '',
			loading: false,
			error: '',
			success: false
		}
	}

    recoverPassword(){
        return fetch(conf.homeURL + "/p/recover", {
            method: "POST",
            headers: { "Content-Type": 'application/json'},
            body: JSON.stringify({
                username: this.state.username
            })
        }).then((r) => {
            return r.json();
        }); 
    }

    onSubmit(){
        if(!this.state.username){
            this.setState({error: 'Please enter your username'});
            return;
        }

        this.setState({loading: true, error: ''});
        this.recoverPassword().then((r) => {
            this.setState({loading: false});
            if(r.error){
                this.setState({error: r.error});
            } else {
                this.setState({success: true, error: ''});
            }
        }).catch((err) => {
            this.setState({loading: false, error: 'An error occurred. Please try again.'});
            console.error(err);
        });
    }


	onChange = (e) => {
		const state = this.state;
		state[e.target.name] = e.target.value;
		this.setState(state);
	};

	render() {
		return(
			<div style = {{display: 'flex', width: '100%', height: '100%', justifyContent: 'center'}}> 
				<form style = {{display: 'flex', width: '300px', flexDirection: 'column', alignItems: 'center', marginTop: '15%'}}> 
               <img src={require('../../images/logo.png')} className="login-logo"/>
               {this.state.success && (
                    <div style={{color: 'green', marginBottom: '10px', textAlign: 'center'}}>
                        Password recovery email sent! Check your email for a reset link.
                    </div>
                )}
               {this.state.error && (
                    <div style={{color: 'red', marginBottom: '10px', textAlign: 'center'}}>
                        {this.state.error}
                    </div>
                )}
				<label className="login">
					<input className="login-input login" type="text" name="username" placeholder="Username" value={this.state.username} onChange={this.onChange}/>
				</label>
				<Button style={{width: '100%'}} bsStyle = "primary" onClick={this.onSubmit.bind(this)} disabled={this.state.loading}>
                    {this.state.loading ? 'Sending...' : 'Recover password'}
                </Button>

			</form>
			</div>
		);
	}
}

